module.exports = __webpack_public_path__ + "images/category_lp/earphone/store_images/5_65a06993174b3ea2e2fe14d144281680.png";